import { render, staticRenderFns } from "./PasswordRestrictionsList.vue?vue&type=template&id=502c6e8c"
import script from "./PasswordRestrictionsList.vue?vue&type=script&lang=js"
export * from "./PasswordRestrictionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports